module.exports = __webpack_public_path__ + "static/media/cirkelKompetance.d3b3d79b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/cirkelKompetance.png
// module id = 1835
// module chunks = 0